<template>
  <div
    class="design mx-auto mdc-layout-grid container mt-5 text-center d-flex align-items-center justify-content-center align-self-center flex-column"
    style="height:100vh!important;"
  >
    <p class="mdc-typography--headline6">
      Aici vei găsi materiale și ghiduri despre brandul nostru.
    </p>
    <h2 class="mdc-typography--body2">Deocamdată e liniște...</h2>

    <!-- <div id="panel" class="panel"></div> -->
  </div>
</template>

<script>
export default {
  name: 'Design',
  metaInfo() {
    return {
      title: this.$t('page_title') || 'Default',
      titleTemplate: '%s | Surfverse',
      meta: [{ name: 'description', content: this.$t('page_description') }]
    }
  }
}
</script>

<i18n>
{
  "en": {
    "page_title": "Design",
    "page_description": "Brand Guidelines",
    "headline": "Welcome to Surfverse, Startups secret launcher.",
    "headline2": "Founders all over the world work on new products, experiences, and services every day. Come with us.🤙"
  },
  "ro": {
    "page_title": "Design",
    "page_description": "Brand Guidelines",
    "headline": "Bun venit pe Surfverse, lansatorul secret al startup-urilor",
    "headline2": "În fiecare zi, fondatori din întreaga lume lucrează la noi produse, experiențe și servicii. Hai cu noi.🤙"
  },
  "de": {
    "page_title": "Design",
    "page_description": "Brand Guidelines",
    "headline": "Willkommen bei Surfverse, Startups Secret Launcher.",
    "headline2": "Gründer auf der ganzen Welt arbeiten jeden Tag an neuen Produkten, Erfahrungen und Dienstleistungen. Komm mit uns.🤙"
  }
}
</i18n>

<style>
.panel {
  width: 100%;
  height: 400px;
  background-color: lawngreen;
  will-change: opacity, transform;
  opacity: 0.25;
  transform-style: preserve-3d;
}
</style>
